import { useMemo } from "react";
import { useTheme } from "./ThemeProvider";

// Brand dark values: charcoal sheet, stone text, the same coral 700 button as light.
const DARK = {
    options: {
        arrowColor: "#181816",
        backgroundColor: "#181816",
        overlayColor: "rgba(8, 8, 7, 0.65)",
        primaryColor: "#be3120",
        textColor: "#f5f5f4",
    },
    tooltip: { boxShadow: "0 0 0 1px #2e2e2a" },
    buttonBack: { color: "#f58571" },
    buttonSkip: { color: "#a8a29e" },
    buttonClose: { color: "#a8a29e" },
};

const mergeStyles = (base = {}, extra) =>
    Object.keys(extra).reduce((out, key) => ({ ...out, [key]: { ...base[key], ...extra[key] } }), { ...base });

/**
 * Styles for a react-joyride tour. Light returns `base` untouched, so each tour looks as it did;
 * dark layers the brand dark values on top. Pass a module-level constant as `base`.
 */
export function useJoyrideStyles(base) {
    const { resolvedTheme } = useTheme();
    return useMemo(() => (resolvedTheme === "dark" ? mergeStyles(base, DARK) : base), [resolvedTheme, base]);
}
